<div class="breadcrumbs" data-ut-breadcrumbs>
    <span data-at-back-breadcrumb [routerLink]="navigateTo" [queryParams]="queryParams" class="breadcrumb-forward">{{
        formerPage
    }}</span>
    <div *ngIf="formerPage && currentPage" data-ut-separator class="breadcrumb-separator">
        <mat-icon>keyboard_arrow_right</mat-icon>
    </div>
    <div class="breadcrumb-active">{{ currentPage }}</div>
</div>
